<template>
  <div>
    <RecentLists v-if="loggedIn" />
    <div v-else style="background-color: #fff;">
      <v-container class="px-10">
        <v-row class="mt-md-10">
          <v-col cols="12" md="6">
            <h1
              class="text-lg-h2 text-md-h2 text-h4 mt-10 text-center text-md-left"
            >
              Learn more words on the go.
            </h1>
            <v-img
              :src="require('../assets/shp1.png')"
              class="d-md-none mt-8"
            />
            <div class="text-h5 font-weight-light mt-10">
              <p>Liteword is an audio flashcard app.</p>

              <p>
                It helps you improve your vocabulary and practice listening
                skills. Eyes and hands free.
              </p>
              <!--
                All while walking, commuting, driving, or doing your daily
                chores.
              -->
              <!-- Put two buttons in a flex container, in small screens they will be stacked -->
              <div class="d-flex flex-row flex-wrap mt-3 mt-lg-8 mb-3">
                <v-btn
                  depressed
                  large
                  class="mr-3"
                  color="primary"
                  href="/accounts/signup"
                  >Try Web App</v-btn
                >
                <v-btn
                  outlined
                  large
                  color="primary"
                  href="/waitinglist/list_signup/?wlc=iphone"
                  class="mt-3 mt-sm-0"
                  >Join iPhone App Waiting List</v-btn
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="d-none d-md-block">
            <img :src="require('../assets/shp1.png')" width="500px" />
          </v-col>
        </v-row>
      </v-container>
      <div style="background-color: #F5F5F5">
        <v-container class="px-10">
          <v-row>
            <v-col class="d-none d-md-block">
              <img :src="require('../assets/shp2.png')" width="448px" />
            </v-col>
            <v-col>
              <p class="text-button">Why does is matter?</p>
              <h2 class="text-h5 text-lg-h4">
                Vocabulary is the key to fast language acquisition.
              </h2>
              <v-img :src="require('../assets/shp2.png')" class="d-md-none" />

              <p class="mt-7 text-subtitle-1 text-lg-h6 font-weight-regular">
                Like a snowball, the more you already know the more new words
                will stick from the input.
              </p>

              <p class="mt-5 text-subtitle-1 text-lg-h6 font-weight-regular">
                <strong>But life moves pretty fast.</strong> How do you find
                time to study vocab?
                <span class="hidden lg:block lg:mt-5"></span>With Liteword you
                can use your chores time efficiently.
              </p>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-container class="px-10">
        <v-row>
          <v-col>
            <p class="text-button">How does it work?</p>
            <ul class="pl-0" style="list-style: none;">
              <li class="mt-10 text-h5 d-flex" style="align-items: center">
                <span
                  style="width: 3rem; height: 3rem; border-radius: 50%; text-align: center; line-height: 2; flex-shrink: 0;"
                  class="d-inline-block grey lighten-2"
                  >1</span
                ><span class="ml-5">Add words you’d like to remember.</span>
              </li>
              <li class="mt-10 text-h5 d-flex" style="align-items: center">
                <span
                  style="width: 3rem; height: 3rem; border-radius: 50%; text-align: center; line-height: 2; flex-shrink: 0;"
                  class="d-inline-block grey lighten-2"
                  >2</span
                ><span class="ml-5"
                  >Liteword turns text into high-fidelity speech
                  instantly.</span
                >
              </li>
              <li class="mt-10 text-h5 d-flex" style="align-items: center">
                <span
                  style="width: 3rem; height: 3rem; border-radius: 50%; text-align: center; line-height: 2; flex-shrink: 0;"
                  class="d-inline-block grey lighten-2"
                  >3</span
                ><span class="ml-5"
                  >Headphones on. Press play and start learning.</span
                >
              </li>
            </ul>

            <p class="mt-10">
              Liteword makes remembering words easy. It’s like playing your
              playlists on repeat.
            </p>
            <p class="mt-4">
              The difference is that Liteword schedules repeats intelligently.
              So you’ll hear things you’re about to forget more frequently.
            </p>
            <p class="mt-4">
              As you learn the material you’ll hear familiar words less
              frequently.
            </p>
            <p class="mt-4">
              This system is also known as
              <a href="https://www.youtube.com/watch?v=cVf38y07cfk"
                >spaced repetition</a
              >, a popular learning technique to improve long-term retention.
            </p>
          </v-col>
          <v-col class="d-none d-md-block" style="position: relative; ">
            <img
              style="position: absolute;"
              :src="require('../assets/interface.png')"
              width="877px"
            />
          </v-col>
        </v-row>
      </v-container>

      <div style="background-color: #F5F5F5">
        <v-container class="px-10 pb-10">
          <p class="text-button">Example Lists</p>
          <v-row>
            <v-col
              v-for="(item, i) in exampleCourses"
              :key="i"
              cols="12"
              sm="6"
            >
              <v-card
                flat
                :to="{
                  name: 'StudyListDetail',
                  params: { id: item.id.toString() },
                }"
              >
                <v-card-title v-text="item.name"></v-card-title>

                <v-card-subtitle
                  v-text="
                    `${item.item_count} ${pluralize(
                      item.item_count,
                      'term',
                      'terms'
                    )}`
                  "
                ></v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <div class="text-center">
            <v-btn text :to="{ name: 'PublicLists' }">View all</v-btn>
          </div>
        </v-container>
      </div>

      <v-container>
        <div class="text-center mt-16">
          <h2 class="text-lg-h4 pt-lg-4 pt-xl-10">
            Start learning vocabulary with Liteword
          </h2>
          <div class="flex-wrap mt-10 mb-16">
            <v-btn
              depressed
              large
              class="mr-3"
              color="primary"
              href="/accounts/signup"
              >Sign up for free</v-btn
            >
            <v-btn
              outlined
              large
              color="primary"
              href="/waitinglist/list_signup/?wlc=iphone"
              class="mt-3 mt-sm-0"
              >Join iPhone App Waiting List</v-btn
            >
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// If user is authenticated we fetch a list
// <router-link to="/about">About</router-link>
import { mapGetters } from "vuex";

import RecentLists from "@/components/RecentLists.vue";

export default {
  name: "Home",

  computed: {
    ...mapGetters(["loggedIn"]),
  },

  methods: {
    pluralize(n, singular, plural) {
      return n !== 1 ? plural : singular;
    },
  },

  data: () => ({
    exampleCourses: [
      {
        id: "690737",
        name: "Spanish Basics",
        item_count: 10,
      },
      {
        id: "865020",
        name: "French Basics",
        item_count: 10,
      },
      {
        id: "971620",
        name: "German Basics",
        item_count: 10,
      },
      {
        id: "484915",
        name: "Russian Basics",
        item_count: 10,
      },
      {
        id: "886563",
        name: "IELTS Advanced Vocabulary",
        item_count: 101,
      },
    ],
  }),

  components: {
    RecentLists,
  },
};
</script>
